<template>
  <div id="wrap" class="animsition">
    <loader v-if="loader == true"></loader>
    <section id="header">
      <header class="clearfix">
        <div
          class="branding logo-sicoob scheme-default"
          align="center"
        >
          <a
            href="javascript:void(0)"
            style="line-height: 45px; margin-left: -80%"
          >
            <span
              ><img
                src="https://sicoobcrediauc-agricredit.softfocus.com.br/public/images/logo/sicoobcrediauc_logo_login.png"
                alt=""
                style="width: 22%; margin-top: -25px;"
            /></span>
          </a>
        </div>
        <div class="branding" style="width: 25% !important; display: flex; justify-content: center; align-items: center;">
          <a class="brand" href="javascript:void(0)" style="color: #309f91">
            <span><strong>SICOOB</strong> AUTO <img src="https://img.icons8.com/?size=100&id=62662&format=png&color=309E8F" width="40px"> </span>
          </a>
        </div>
        <ul
          class="nav-right pull-right list-inline"
          v-if="$route.name != 'IndexSimulacao'"
        >
          <!-- USUARIO -->
          <li class="dropdown nav-profile">
            <a href class="dropdown-toggle" data-toggle="dropdown">
              <img
                :src="$root.baseUrl + '/static/avatar.png'"
                alt=""
                class="img-circle size-30x30"
              />
              <span>{{ usuario }} <i class="fa fa-angle-down"></i></span>
            </a>
            <ul class="dropdown-menu animated littleFadeInRight" role="menu">
              <li>
                <a href="javascript:void(0)" @click="logout()">
                  <i class="fa fa-power-off"></i>Logout
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </header>
    </section>
    <div id="controls" v-if="$route.name != 'IndexSimulacao'">
      <aside id="sidebar">
        <div id="sidebar-wrap">
          <div class="panel-group slim-scroll" role="tablist">
            <div class="panel panel-default">
              <div class="panel-heading" role="tab">
                <h4 class="panel-title">
                  <a data-toggle="collapse" href="/#sidebarNav">
                    Navigation <i class="fa fa-angle-up"></i>
                  </a>
                </h4>
              </div>
              <div
                id="sidebarNav"
                class="panel-collapse collapse in"
                role="tabpanel"
              >
                <div class="panel-body">
                  <ul id="navigation">
                    <li
                      @click="msgSairPagina()"
                      :class="
                        $route.name == 'IndexPropostas' ||
                        $route.name == 'NovaProposta' ||
                        $route.name == 'EditarProposta' ||
                        $route.name == 'ViewProposta' ||
                        $route.name == 'Inicio'
                          ? 'active'
                          : ''
                      "
                    >
                      <router-link :to="''">
                        <img src="https://img.icons8.com/?size=100&id=82690&format=png&color=000000" width="30px"><br>
                        <span>Simulações</span>
                      </router-link>
                    </li>
                    <li
                      :class="
                        $route.name == 'IndexConfigContas' ? 'active' : ''
                      "
                    >
                      <router-link :to="{ name: 'IndexConfigContas' }">
                        <img src="https://img.icons8.com/?size=100&id=42850&format=png&color=000000" width="25px"><br>
                        <span>Configurações</span>
                      </router-link>
                    </li>
                    <li
                      :class="
                        $route.name == 'IndexVendedores' ? 'active' : ''
                      "
                    >
                      <router-link :to="{ name: 'IndexVendedores' }">
                        <img src="https://img.icons8.com/?size=100&id=13042&format=png&color=000000" width="25px"><br>
                        <span>Vendedores</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
    <nav
      class="navbar navbar-default"
      style="
        z-index: 999 !important;
        display: none;
        position: fixed !important;
        width: 100% !important;
      "
    >
      <div class="container-fluid">
        <div class="navbar-header">
          <button
            v-if="$route.name != 'IndexSimulacao'"
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link :to="{ name: 'IndexPropostas' }" class="navbar-brand">
            <img
              src="https://sicoobcrediauc-agricredit.softfocus.com.br/public/images/logo/sicoobcrediauc_logo_login.png"
              alt=""
              style="height: 136%; margin-top: -5px"
            />
          </router-link>
        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav">
            <li @click="ocultaMenu()">
              <router-link :to="{ name: 'IndexPropostas' }">
                Todas as Simulações
              </router-link>
            </li>
            <li @click="ocultaMenu()">
              <router-link :to="{ name: 'NovaProposta' }">
                Nova Simulação
              </router-link>
            </li>
            <li @click="ocultaMenu()">
              <router-link :to="{ name: 'IndexConfigContas' }">
                Contas de Retorno
              </router-link>
            </li>
            <li class="dropdown">
              <a href class="dropdown-toggle" data-toggle="dropdown">
                <span> {{ usuario }} <i class="fa fa-angle-down"></i></span>
              </a>
              <ul class="dropdown-menu animated littleFadeInRight" role="menu">
                <li>
                  <a href="javascript:void(0)" @click="logout()">
                    <i class="fa fa-sign-out"></i>Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <transition name="slide-fade">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  name: "default-container",
  data() {
    return {
      usuario: localStorage.username,
      loader: false,
    };
  },
  methods: {
    logout: function () {
      var $this = this;
      $this.loader = true;
      $this.$http.get("/logout").then(function (response) {
        localStorage.setItem("token", null);
        localStorage.setItem("username", null);
        localStorage.setItem("seguro", null);
        localStorage.setItem("feirao", null);
        $this.$router.push({ name: "Login" });
        $this.loader = false;
      });
    },

    msgSairPagina() {
      let $this = this;
      swal({
        title: "Atenção",
        text: "Alterações serão Perdidas. Tem certeza que deseja sair mesmo assim ?",
        type: "warning",
        buttons: true,
        showCancelButton: true,
        dangerMode: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((r) => {
        if (r.value) {
          $this.$router.push({ path: "/" });
        }
      });
    },

    ocultaMenu: function () {
      $(".navbar-collapse").removeClass("in");
    },
  },
};
</script>
<style>
body {
  background: #e7eaeb !important;
}
</style>



// WEBPACK FOOTER //
// src/containers/Default.vue